'use client';

import { QRCodeSVG } from 'qrcode.react';
import { cn } from '@/lib/utils';

export interface AddressQrCodeProps {
  /** 编码进二维码的钱包地址 */
  value: string;
  /** 中心内嵌的链图标 URL；缺省时输出纯二维码 */
  iconUrl?: string;
  /** 整体边长（px），默认 174（同 Figma size-43.5） */
  size?: number;
  className?: string;
}

/**
 * 钱包地址二维码：白底圆角卡片，中心内嵌链图标。
 * 纠错级别 H（30%）+ 图标占边长约 1/5，保证挖空中心后仍可扫码。
 */
export default function AddressQrCode({
  value,
  iconUrl,
  size = 174,
  className,
}: AddressQrCodeProps) {
  const padding = 12;
  const qrSize = size - padding * 2;
  const iconSize = Math.round(qrSize * 0.2);

  return (
    <div
      className={cn('flex items-center justify-center rounded-xl bg-white', className)}
      style={{ width: size, height: size }}
    >
      <QRCodeSVG
        value={value}
        size={qrSize}
        level="H"
        marginSize={0}
        imageSettings={
          iconUrl
            ? { src: iconUrl, width: iconSize, height: iconSize, excavate: true }
            : undefined
        }
      />
    </div>
  );
}
